import { createApp } from 'vue';
import { createRouter, createWebHistory, RouterView } from 'vue-router';
import App from './App.vue';
import ShareLink from './components/ShareLink.vue';
import AuthCallback from './views/AuthCallback.vue';

const routes = [
  {
    path: '/',
    component: App,
    meta: { title: 'FileShare' },
  },
  {
    path: '/auth/callback',
    component: AuthCallback,
    meta: { title: 'FileShare — ログイン中' },
  },
  {
    path: '/share/:token',
    component: ShareLink,
    meta: { title: 'FileShare — ファイルダウンロード' },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.afterEach((to) => {
  document.title = to.meta.title || 'FileShare';
});

const app = createApp(RouterView);
app.use(router);
app.mount('#app');
